import React from 'react';
import { Container, Row, Col, Alert, Form, Button} from 'react-bootstrap';
import { useState } from 'react';
import getBackend from 'backend/backend';
import { Paths } from 'paths';
import { GoogleLogin } from '@react-oauth/google';
import { DividerOr } from 'components/misc';
import { useTranslation } from "react-i18next";
import Page from 'components/page';

const Signup = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [t] = useTranslation('common');

    const doSignin = async (authType, name, password) => {
        setError("");
        setLoading(true);

        const result = await getBackend().signin({auth_type: authType, name: name, password: password});
        if (result.error != null) {
            setError(result.error);
        } else {
            window.location.href = Paths.Console.path;
        }

        setLoading(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        setError("");
        setLoading(true);

        const result = await getBackend().signup({auth_type: "email", name: email, password: password});
        if (result.error != null) {
            setError(result.error);
        } else {
            if (process.env.REACT_APP_ENV_TYPE === "onpremise") {
                window.location.href = Paths.Signin.path;
            } else {
                window.location.href = Paths.VerifyEmail.path;
            }
        }

        setLoading(false);
    };

    return (
        <Page title={t('Create Your Account | Free Registration')} description={t('Join our community by creating a free account. Sign up to access exclusive features, personalized content, and connect with other users.')} canonicalUrl={Paths.Signup.path}>
        <Container>
            <Row className="justify-content-md-center vh-100">
                <Col md={6}>
                <h2 className="my-4 text-center">{t('Sign Up')}</h2>
                {error && <Alert variant="danger">{error}</Alert>}
                <GoogleLogin
                    onSuccess={credentialResponse => {
                        doSignin("google", "", credentialResponse.credential);
                    }}
                    onError={() => {
                        setError(t('Google signin: something went wrong'));
                    }}
                />
                <DividerOr/>
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="name">
                    <Form.Label>{t('Email')}</Form.Label>
                    <Form.Control
                        type="text"
                        className="custom-input"
                        placeholder={t('Enter your email')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    </Form.Group>

                    <Form.Group controlId="password">
                    <Form.Label>{t('Password')}</Form.Label>
                    <Form.Control
                        type="password"
                        className="custom-input"
                        placeholder={t('Enter your password')}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                    </Form.Group>

                    <Button className="custom-button mt-3" variant="light" type="submit" disabled={loading}>
                        {loading ? t('Signing Up...') : t('Sign Up')}
                    </Button>
                </Form>
                </Col>
            </Row>
        </Container>
        </Page>
  );
};

export default Signup;